// @flow
/* eslint-disable max-len */

import { defineMessages } from 'react-intl';

export default defineMessages({
    INVALID_OLD_PASSWORD: {
        id: 'authentication.invalid-old-password',
        defaultMessage: 'Oops! That does not look like your old password, please try again.'
    },
    INVALID_NEW_PASSWORD: {
        id: 'authentication.invalid-new-password',
        defaultMessage: 'Oops! Your password must be 8 characters or more with at least one number.'
    }
});



// WEBPACK FOOTER //
// ./src/core/state/authentication/intl.js